// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * WL.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface LongWriteResultDelete
 */
export interface LongWriteResultDelete {
  /**
   *
   * @type {string}
   * @memberof LongWriteResultDelete
   */
  eventId?: string | null
}

/**
 * Check if a given object implements the LongWriteResultDelete interface.
 */
export function instanceOfLongWriteResultDelete(value: object): boolean {
  let isInstance = true

  return isInstance
}

export function LongWriteResultDeleteFromJSON(
  json: any,
): LongWriteResultDelete {
  return LongWriteResultDeleteFromJSONTyped(json, false)
}

export function LongWriteResultDeleteFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LongWriteResultDelete {
  if (json === undefined || json === null) {
    return json
  }
  return {
    eventId: !exists(json, 'eventId') ? undefined : json['eventId'],
  }
}

export function LongWriteResultDeleteToJSON(
  value?: LongWriteResultDelete | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    eventId: value.eventId,
  }
}
